import React, { useState, useEffect, useReducer } from 'react';
import {
  Row, Col,
  Divider,
  Button,
  Radio,
  Form, Input, Select, Tabs,
  Space,
  Checkbox,
  message
} from 'antd';
import {
  CloseOutlined,
  CheckOutlined,
  SaveOutlined
} from '@ant-design/icons';
import { MasterContext } from '../../App';
import {
  getList as getAuthorities
} from '../../services/Authority';
import { getListEnabled } from '../../services/Entity';
import { getListEnabled as getSupplierList } from '../../services/Supplier';
import './style';
export default React.forwardRef((props, ref) => {
  const { user, title, onCloseCallback, onSaveCallback } = props;
  const [form] = Form.useForm();
  const [account, setAccount] = useState(user ? user.account : undefined);
  const [name, setName] = useState(user ? user.name : undefined);
  const [tel, setTel] = useState(user ? user.tel : undefined);
  const [email, setEmail] = useState(user ? user.email : undefined);
  const [enabled, setEnabled] = useState(user ? user.enabled : true);
  const [loginAble, setLoginAble] = useState(user ? user.enabled : true);
  const [compnayId, setCompanyId] = useState(user ? user.company_id : undefined);
  const [displayOrder, setDisplayOrder] = useState(user ? user.display_order : 1);
  const [authorities, setAuthorities] = useState([]);
  const [categoryId, setCategoryId] = useState(user ? user.category_id : 2);
  const [suppliers, setSuppliers] = useState([]);
  const [warehouses, setWarehouses] = useState([])
  const [userPermissonCategory, setUserPermissionCategory] = useState([]);
  const [userPermission, setUserPermission] = useState([]);

  useEffect(() => {
    if (user && user.id) {
      getAuthorities(user.id).then(data => setAuthorities(data));
    }

    getSupplierList().then(data => {
      const temp = [{ id: 0, name: '-' }].concat((data || []));
      setSuppliers(temp);
    });
    getListEnabled('fm_warehouse').then(data => setWarehouses(data));
    getListEnabled('fm_user_role_permission_category').then(data => {
      setUserPermissionCategory(data);
    });
    getListEnabled('fm_user_role_permission').then(data => {
      setUserPermission(data);
    });
  }, []);

  const onSave = async () => {
    const values = await form.validateFields();
    let permissions = [];
    userPermissonCategory.forEach(x => {
      if (values[x.id]) {
        permissions = permissions.concat(values[x.id].map(y => ({ category_id: x.id, permission_id: y })))
      }
    });

    const params = {
      user: values,
      permissions: permissions
    };

    if (onSaveCallback) {
      onSaveCallback(params, onClose);
    }
  }

  const onClose = async () => {
    try {
      if (onCloseCallback) {
        onCloseCallback();
      }
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onChangeUIPermission = (checked, permissionId) => {
    let temp = [].concat(authorities || []);
    if (temp.find(x => x.permission_id === permissionId)) {
      if (!checked) {
        temp.splice(temp.indexOf(temp.find(x => x.permission_id === permissionId)), 1);
        const t = temp.filter(x => x.category_id === permissionId);
        t.map((item) => {
          temp.splice(temp.indexOf(item), 1);
        });
      }
    } else {
      if (checked) {
        temp.push({ permission_id: permissionId });
      }
    }
    setAuthorities(temp);
  }

  const initValue = userPermissonCategory.map((item) => (
    { name: item.id, value: (authorities || []).filter(a => userPermission.filter(y => y.category_id === item.id).find(z => z.id === a.permission_id)).map(x => x.permission_id) }
  )).concat([
    { name: 'id', value: user && user.id },
    { name: 'category_id', value: categoryId },
    { name: 'account', value: account },
    { name: 'name', value: name },
    { name: 'company_id', value: compnayId },
    { name: 'tel', value: tel },
    { name: 'email', value: email },
    { name: 'display_order', value: displayOrder },
    { name: 'enabled', value: enabled },
    { name: 'login_able', value: loginAble },
  ]);

  const onChangeType = (type) => {
    if (type === 1) {

    } else if (type === 3) {

    } else {

    }
    setCategoryId(type);
  }
  return (
    <Form style={{ height: '100%' }} form={form} preserve={false} onFinish={onSave} fields={initValue}>
      <Row style={{ height: '100%', flexFlow: 'nowrap' }}>
        <Col flex="400px" className="order-new-left-panel">
          <Form.Item hidden={true} name="id" >
            <Input />
          </Form.Item>
          <Form.Item label="分类" name="category_id" rules={[{ required: true, message: '请选择用户类型!' }]}>
            <Radio.Group onChange={(e) => onChangeType(e.target.value)}>
              <Radio value={1}>管理员</Radio>
              <Radio value={2}>业务员</Radio>
              <Radio value={3}>供应商</Radio>
              <Radio value={4}>仓库管理员</Radio>
              <Radio disabled value={5}>客户</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item label="登录帐号" name="account" rules={[{ required: true, message: '请输入登录帐号!' }]}>
            <Input
              autocomplete="off"
              onChange={(e) => setAccount(e.target.value)}
              placeholder="如：zhangsan"
            >
            </Input>
          </Form.Item>
          {
            categoryId === 3 && <Form.Item label="供应商　" name="company_id" rules={[{ required: true, message: '请选择供应商!' }]}                            >
              <Select placeholder="请选择所属供应商" allowClear value={compnayId} showSearch onChange={setCompanyId}>
                {
                  suppliers.map(x => {
                    return <Select.Option key={x.id} value={x.id}>
                      {x.name}
                    </Select.Option>
                  })
                }
              </Select>
            </Form.Item>
          }
          {
            categoryId === 4 && <Form.Item label="所属仓库" name="company_id" rules={[{ required: true, message: '请选择仓库!' }]}                            >
              <Select placeholder="请选择所属仓库" allowClear value={compnayId} showSearch onChange={setCompanyId}>
                {
                  warehouses.map(x => {
                    return <Select.Option key={x.id} value={x.id}>
                      {x.name}
                    </Select.Option>
                  })
                }
              </Select>
            </Form.Item>
          }
          {
            categoryId === 3 && <Form.Item label="联系人　" name="name" rules={[{ required: true, message: '请输入联系人!' }]}>
              <Input
                autocomplete="off"
                onChange={(e) => setName(e.target.value)}
                placeholder="请输入联系人"
              >
              </Input>
            </Form.Item>
          }
          {
            categoryId != 3 && <Form.Item label="用户姓名" name="name" rules={[{ required: true, message: '请输入用户名称!' }]}>
              <Input
                autocomplete="off"
                onChange={(e) => setName(e.target.value)}
                placeholder="请输入用户名称"
              >
              </Input>
            </Form.Item>
          }
          <Form.Item label="邮　　箱" name="email" rules={[{ required: true, message: '请输入用户邮箱!' }]}                            >
            <Input
              autocomplete="off"
              onChange={(e) => setEmail(e.target.value)}
              placeholder="请输入用户邮箱"
            >
            </Input>
          </Form.Item>
          <Form.Item label="电　　话" name="tel" rules={[{ required: true, message: '请输入用户电话!' }]}                            >
            <Input
              autocomplete="off"
              onChange={(e) => setTel(e.target.value)}
              placeholder="请输入客户电话"
            >
            </Input>
          </Form.Item>
          <Form.Item label="显示顺序" name="display_order" rules={[{ required: true, message: '请输入显示顺序!' }]}                            >
            <Input
              autocomplete="off"
              onChange={(e) => setDisplayOrder(e.target.value)}
              placeholder="请输入客户电话"
            >
            </Input>
          </Form.Item>
          <Form.Item label="是否启用" name="enabled" valuePropName="checked" rules={[{ required: true, message: '请选择是否启用该用户!' }]}                            >
            <Checkbox onChange={(e) => setEnabled(e.target.checked)}></Checkbox>
          </Form.Item>
          <Form.Item label="允许登录系统" name="login_able" valuePropName="checked" rules={[{ required: true, message: '请选择是否允许该用户登录系统!' }]}                            >
            <Checkbox onChange={(e) => setLoginAble(e.target.checked)}></Checkbox>
          </Form.Item>
        </Col>
        <Col flex="calc(100% - 400px)" style={{ padding: '1rem' }}>
          <h3>用户权限</h3>
          <Divider />
          {
            categoryId === 1 && <div style={{ minHeight: '10rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><h3>管理员用户，持有所有权限，无需设置。</h3></div>
          }
          {
            categoryId === 3 && <div style={{ minHeight: '10rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><h3>供应商用户，仅可登录供应商系统，无需设置。</h3></div>
          }
          {
            categoryId === 4 && <div style={{ minHeight: '10rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><h3>仓库管理员，仅可登录仓库管理系统，无需设置。</h3></div>
          }
          {
            (categoryId === 2) && userPermissonCategory.filter(x => x.id === 1).map((item, index) => {
              return <Form.Item name={item.id} label={`${index + 1}. ${item.name}`}>
                <Checkbox.Group>
                  {
                    userPermission
                      .filter(x => x.category_id === item.id)
                      .map((permission, index) => {
                        return <Checkbox onChange={(e) => onChangeUIPermission(e.target.checked, permission.id)} key={permission.id} value={permission.id} >{permission.name}</Checkbox>
                      })
                  }
                </Checkbox.Group>
              </Form.Item>
            })
          }
          {
            (categoryId === 2) && userPermissonCategory.filter(x => x.id > 1 && x.id < 7).map((item, index) => {
              return <Form.Item name={item.id} label={`${index + 2}. ${item.name}`}>
                <Checkbox.Group>
                  {
                    userPermission
                      .filter(u => u.category_id === item.id)
                      .map((permission, index) => {
                        return <Checkbox
                          disabled={(authorities || []).find(y => y.permission_id === item.id) === undefined}
                          key={permission.id}
                          value={permission.id} >
                          {permission.name}
                        </Checkbox>
                      })
                  }
                </Checkbox.Group>
              </Form.Item>
            })
          }
          {
            (categoryId === 2) && userPermissonCategory.filter(x => x.id === 7).map((item, index) => {
              return <Form.Item name={item.id} label={`${index + 7}. ${item.name}`}>
                <Checkbox.Group>
                  {
                    userPermission
                      .filter(x => x.category_id === item.id)
                      .map((permission, index) => {
                        return [
                          (index > 0 && index % 4 === 0) && <br />,
                          <Checkbox
                            disabled={(authorities || []).find(y => y.permission_id === item.id) === undefined}
                            key={permission.id}
                            value={permission.id} >
                            {permission.name}
                          </Checkbox>
                        ]
                      })
                  }
                </Checkbox.Group>
              </Form.Item>
            })
          }
          <Divider />
          <Row justify="end">
            <Space align="end" size="large">
              <Button icon={<CloseOutlined />} onClick={onClose}>关 闭</Button>
              <Button icon={<SaveOutlined />} htmlType="submit" type="primary">保 存</Button>
            </Space>
          </Row>
        </Col>
      </Row>
    </Form>
  )
});
